import { Transform } from "class-transformer";
import { toEuros } from "@/utils/numberUtils";

export class PurchaseOrdersTotalDto {
  @Transform(({ value }) => toEuros(value))
  total: string;
}
